// eslint-disable-next-line
export const applyLinkMetadata = (items, links, linkIdField, overrideFields) =>
  items.map(item => {
    const link = links.find(l => l[linkIdField] === item.id);
    const overrides = overrideFields.reduce((acc, field) => ({ ...acc, [field]: link[field] }), {});
    return { ...item, ...overrides };
  });

export const applyQuestionLinkMetadata = question => {
  let choices = [];
  let matrixChoices = [];

  if (question.choices) {
    choices = applyLinkMetadata(question.choices, question.choiceLinks, 'choiceId', [
      'polarity',
      'order',
    ]).sort((a, b) => a.order - b.order);
  }

  if (question.matrixChoices !== undefined) {
    matrixChoices = applyLinkMetadata(
      question.matrixChoices,
      question.matrixChoiceLinks,
      'matrixChoiceId',
      ['order'],
    ).sort((a, b) => a.order - b.order);
  }

  return { ...question, choices, matrixChoices };
};

// eslint-disable-next-line
export const groupMediaQuestions = questions => {
  const firstMediaIndex = questions.findIndex(q => q.questionType === 'MEDIA');
  const questionList = questions.filter(q => q.questionType !== 'MEDIA');

  // No media questions, set up a blank group
  if (firstMediaIndex === -1) {
    questionList.push({
      questionType: 'MEDIA',
      title: 'Media survey',
      group: [],
      matrixChoices: [],
    });
  } else {
    const mediaQuestionList = questions.filter(q => q.questionType === 'MEDIA');

    // Media questions in a group should always use the same questions
    // so we'll only concern ourselves with the choices of the first
    const matrixChoices = mediaQuestionList[0].matrixChoices;

    const groupedMediaQuestion = {
      questionType: 'MEDIA',
      title: 'Media survey',
      group: mediaQuestionList,
      matrixChoices,
    };

    // Add the media group into the position where we found the first media entry before.
    questionList.splice(firstMediaIndex, 0, groupedMediaQuestion);
  }

  return questionList;
};

export const ungroupMediaQuestions = questions => {
  const mediaGroupIndex = questions.findIndex(q => q.questionType === 'MEDIA');

  // No media group questions found, o need to continue further
  if (mediaGroupIndex === -1) {
    return questions;
  }

  const questionList = questions.filter(q => q.questionType !== 'MEDIA');
  const matrixChoices = questions[mediaGroupIndex].matrixChoices.map(mc => ({
    id: mc.id,
    name: mc.name,
    title: mc.title,
    visibleIf: mc.visibleIf,
    isRequired: true,
    choices: mc.choices,
  }));
  const mediaQuestionList = questions[mediaGroupIndex].group
    // Set the matrix choices on each question in our group
    .map(mq => ({ ...mq, mediaClipId: mq.mediaClip.id, matrixChoices }));

  questionList.splice(mediaGroupIndex, 0, ...mediaQuestionList);

  return questionList;
};



// WEBPACK FOOTER //
// ./src/store/modules/surveybuilder/helpers.js